import { ACTIONS } from "../../consts/booking"
import {
  ACTION_REQUEST as MMB_ACTION_REQUEST,
  ACTION_FAILURE as MMB_ACTION_FAILURE,
} from "../../scenes/AccountBooking/components/Booking/services/consts"
import {
  SUBMIT_FAILURE,
  SUBMIT_REQUEST,
} from "../../scenes/AccountBooking/components/Booking/services/additionalServices/consts"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapActionTypeToDataDogEventName = (action: { type: string; action: any }) => {
  switch (action.type) {
    case SUBMIT_REQUEST:
    case MMB_ACTION_REQUEST:
      return [ACTIONS.ADDITIONAL_CONTACTS, ACTIONS.CANCEL_BOOKING].includes(action.action)
        ? // Fix this the next time the file is edited. (Flow to TS)
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          `mmb/${action.action}/request`
        : ""
    case SUBMIT_FAILURE:
    case MMB_ACTION_FAILURE:
      return [ACTIONS.ADDITIONAL_CONTACTS, ACTIONS.CANCEL_BOOKING].includes(action.action)
        ? // Fix this the next time the file is edited. (Flow to TS)
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          `mmb/${action.action}/failure`
        : ""

    default:
      return ""
  }
}
